import type { CopilotProposalId } from "@repo/app-types/entities/copilotProposal";
import type { SignalId } from "@repo/app-types/entities/signal";
import type { To } from "react-router";
import { appPaths } from "../../../app/appPaths.js";

export const SIGNAL_PROPOSAL_QUERY_PARAM = "proposalId";

/** The editor's path: the signal's own, or the new-signal editor without one. */
export function buildSignalEditorPathname(
  signalId: SignalId | undefined,
): string {
  return signalId
    ? appPaths.settingsSignal.build({ signalId })
    : appPaths.settingsNewSignal.build();
}

/**
 * The editor location that puts a copilot proposal into the draft. A
 * `create_signal` proposal has no saved signal, so it opens the new-signal
 * editor.
 */
export function buildSignalProposalEditLocation(props: {
  signalId: SignalId | undefined;
  proposalId: CopilotProposalId;
}) {
  const searchParams = new URLSearchParams({
    [SIGNAL_PROPOSAL_QUERY_PARAM]: props.proposalId,
  });
  return {
    pathname: buildSignalEditorPathname(props.signalId),
    search: `?${searchParams.toString()}`,
  } satisfies To;
}
